import PageWrap from "../../../../layout/PageWrap";

const HomeEditor = () => {
  return <PageWrap title="Manage" content={<></>} />;
};

export default HomeEditor;
